/**
 * Returns the first photo from the variant on a quote.
 *
 * @param quote The quote to get the variant photo for
 * @returns {string|undefined}
 */
export default (quote) => {
  let variant = quote.variant || {};
  if (!variant.photos || !variant.photos.length) {
    return undefined;
  }
  return variant.photos[0].path;
};
